import React from "react";
import { graphql } from "gatsby";
import { CTABar } from "./CTABar";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentLinkedVectorArt,
  KontentLinks,
  KontentMultiChoice,
  KontentRichText,
  LeftRight,
} from "../../../types/index";
import { getMultiChoice } from "../../../lib/multichoice";
import { formatLinks } from "../../../lib/links";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatVector } from "../../../lib/images";

export type CTAStyles = "white_background" | "dark_background";

interface Props extends KontentComponentSettings, KontentComponentLayout {
  link_configuration__link: KontentLinks;
  style: KontentMultiChoice<CTAStyles>;
  heading: KontentRichText;
  vector: KontentLinkedVectorArt;
  vector_placement: KontentMultiChoice<LeftRight>;
}

const CTABarContainer: React.FC<Props> = ({
  style,
  heading,
  link_configuration__link,
  vector,
  vector_placement,
  ...props
}) => {
  const cta = formatLinks(link_configuration__link?.modular_content)[0];
  const componentSettings = getComponentSettings({ ...props });

  return (
    <CTABar
      heading={heading}
      style={getMultiChoice(style)}
      cta={cta}
      vector={formatVector(vector.value[0]?.elements)}
      vectorPlacement={getMultiChoice(vector_placement)}
      {...componentSettings}
    />
  );
};

export default CTABarContainer;

export const fragmentCTAContainer = graphql`
  fragment CTABar on kontent_item_cta_bar {
    elements {
      style {
        value {
          codename
        }
      }
      heading {
        ...kontentSimpleRichText
      }
      link_configuration__link {
        modular_content {
          ...kontentRichTextLink
        }
      }
      vector {
        value {
          ...kontentVectorArt
        }
      }
      vector_placement {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
